export function designStudioItemsEnabled(projectStore) {
  return Boolean(projectStore.getters['user/ds2'])
}

export function projectCartRoute(id) {
  return id
    ? { name: 'projects-detail-cart', params: { id: String(id) } }
    : { name: 'cart' }
}

export function projectCheckoutRoute(id) {
  return id
    ? { name: 'projects-detail-checkout', params: { id: String(id) } }
    : { name: 'checkout' }
}
